'use client';

import * as LabelPrimitive from '@radix-ui/react-label';
import { cva, type VariantProps } from 'class-variance-authority';
import * as React from 'react';

import { cn } from '@/utils/utils_client';

// 1. Define your style and size variants inside CVA
const labelVariants = cva('font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70', {
  variants: {
    // Style / Color variants
    variant: {
      bar: 'text-bar-foreground',
      'component-item': 'text-component-item-foreground',
      default: 'text-foreground',
    },
    // Size variants
    size: {
      xs: 'text-xs',
      md: 'text-md',
      base: 'text-base',
      lg: 'text-lg',
      xl: 'text-xl',
    },
  },
  // 2. Setup your fallback/default options
  defaultVariants: {
    variant: 'default',
    size: 'md',
  },
});

export const UI_PRIMITIVE__label = React.forwardRef<
  React.ElementRef<typeof LabelPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof LabelPrimitive.Root> & VariantProps<typeof labelVariants>
>(({ className, variant, size, ...props }, ref) => (
  <LabelPrimitive.Root
    ref={ref}
    // 3. Pass the variant and size props into the variant generator
    className={cn(labelVariants({ variant, size }), className)}
    {...props}
  />
));

UI_PRIMITIVE__label.displayName = LabelPrimitive.Root.displayName;
